import type { MentionTarget } from "@serophin/shared";
import type { JSX } from "preact";
import { Avatar } from "./Avatar";
import type { MarkdownEditorTheme } from "./markdownEditorTheme";

type MentionSuggestionsProps = {
  targets: MentionTarget[];
  theme: MarkdownEditorTheme;
  highlightedIndex: number;
  onHighlight: (index: number) => void;
  onSelect: (target: MentionTarget) => void;
  style: JSX.CSSProperties;
  containerRef: (node: HTMLDivElement | null) => void;
};

export const MentionSuggestions = ({ targets, theme, highlightedIndex, onHighlight, onSelect, style, containerRef }: MentionSuggestionsProps) => (
  <div ref={containerRef} role="listbox" style={style} class={`absolute z-30 w-64 max-w-[calc(100vw-2rem)] max-h-48 overflow-y-auto py-1 ${theme.popup}`}>
    {targets.length === 0 ? (
      <p class={theme.popupEmpty}>No matches</p>
    ) : (
      targets.map((target, index) => (
        <button
          key={target.id}
          type="button"
          role="option"
          aria-selected={index === highlightedIndex}
          onMouseDown={(event) => {
            event.preventDefault();
            onSelect(target);
          }}
          onMouseEnter={() => onHighlight(index)}
          class={`flex w-full items-center gap-2 px-3 py-1.5 text-left ${index === highlightedIndex ? theme.popupActive : theme.popupInactive}`}
        >
          <Avatar name={target.label} size="sm" />
          <span class="min-w-0 flex-1">
            <span class={theme.popupLabel}>{target.label}</span>
            {target.title && <span class={theme.popupTitle}>{target.title}</span>}
          </span>
        </button>
      ))
    )}
  </div>
);
